export const ITEM_HEIGHT = 36;
export const DEFAULT_ITEM_LIST_HEIGHT = 5 * ITEM_HEIGHT;
